(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_variant-thumbs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('variant-thumbs')) {
    customElements.define(
      'variant-thumbs',
      class VariantThumbs extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', this.#onSelect);
          this.addEventListener('mouseover', this.#onSelect);
        }

        #onSelect = (event) => {
          const button = event.target.closest('.variant-thumbs__item');
          if (!button || button.classList.contains('is-active')) return;
          if (event.type === 'click') event.preventDefault();

          const card = this.closest('product-card, .product-card');
          if (!card) return;

          const slide =
            card.querySelector('slideshow-slide[aria-hidden="false"] img') ||
            card.querySelector('.card-gallery img');
          if (slide) {
            slide.removeAttribute('srcset');
            slide.src = button.dataset.src;
            slide.srcset = button.dataset.srcset;
          }

          card.querySelectorAll('a[href*="/products/"]').forEach((link) => {
            link.href = button.dataset.url;
          });

          this.querySelectorAll('.variant-thumbs__item').forEach((el) => el.classList.toggle('is-active', el === button));
        };
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lens-cat-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lens-cat-bar-sync')) {
    customElements.define(
      'lens-cat-bar-sync',
      class LensCatBarSync extends HTMLElement {
        connectedCallback() {
          try {
            this.map = JSON.parse(this.querySelector('[data-cat-map]').textContent);
          } catch (e) {
            this.map = {};
          }
          this.onChange = () => [150, 500, 1000, 2000].forEach((ms) => setTimeout(() => this.sync(), ms));
          document.addEventListener('change', this.onChange);
          document.addEventListener('variant:update', this.onChange);
          window.addEventListener('popstate', this.onChange);
        }

        disconnectedCallback() {
          document.removeEventListener('change', this.onChange);
          document.removeEventListener('variant:update', this.onChange);
          window.removeEventListener('popstate', this.onChange);
        }

        currentVariantId() {
          const section = this.closest('.shopify-section') || document;
          const input = section.querySelector('form[action*="/cart/add"] input[name="id"]');
          if (input && input.value) return input.value;
          return new URL(window.location.href).searchParams.get('variant');
        }

        sync() {
          const id = this.currentVariantId();
          const range = id && this.map[id];
          if (!range) return;
          const [min, max] = range;
          const bar = this.querySelector('.lens-cat-bar');
          if (!bar) return;
          const fill = bar.querySelector('.lens-cat-bar__fill');
          if (fill) {
            fill.style.left = min * 25 + '%';
            fill.style.width = (max - min) * 25 + '%';
          }
          bar.querySelectorAll('.lens-cat-bar__point').forEach((point) => {
            const i = Number((point.className.match(/lens-cat-bar__point--(\d)/) || [])[1]);
            point.classList.toggle('is-active', i >= min && i <= max);
          });
          const ticks = bar.querySelectorAll('.lens-cat-bar__tick');
          if (ticks.length) {
            const track = bar.querySelector('.lens-cat-bar__track');
            ticks.forEach((t) => t.remove());
            for (let i = min; i <= max; i++) {
              const tick = document.createElement('span');
              tick.className = 'lens-cat-bar__tick';
              tick.style.left = i * 25 + '%';
              track.appendChild(tick);
            }
          }
          const prefix = (bar.getAttribute('aria-label') || 'Cat.').split(' ')[0];
          bar.setAttribute('aria-label', prefix + ' ' + min + ' - ' + max);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["offer-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('offer-countdown')) {
    customElements.define(
      'offer-countdown',
      class OfferCountdown extends HTMLElement {
        connectedCallback() {
          this.end = Number(this.dataset.end) * 1000;
          this.out = this.querySelector('[data-time]');
          this.tick();
          this.timer = setInterval(() => this.tick(), 1000);
        }
        disconnectedCallback() {
          clearInterval(this.timer);
        }
        tick() {
          const left = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
          if (!left) {
            clearInterval(this.timer);
            this.hidden = true;
            return;
          }
          const p = (n) => String(n).padStart(2, '0');
          this.out.textContent = `${p(Math.floor(left / 3600))}:${p(Math.floor((left % 3600) / 60))}:${p(left % 60)}`;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-addons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-addons')) {
    customElements.define(
      'product-addons',
      class ProductAddons extends HTMLElement {
        connectedCallback() {
          // Segunda gafa (pack 2): como mucho una marcada. Las lentes admiten varias.
          this.addEventListener('change', (event) => {
            const input = event.target;
            // Casilla "Lente extra": al desmarcarla se quitan las lentes elegidas
            if (input instanceof HTMLInputElement && input.matches('[data-addon-toggle]')) {
              if (!input.checked) {
                input.closest('.product-addons__toggle-group')?.querySelectorAll('input[data-addon-variant]').forEach((i) => {
                  i.checked = false;
                });
              }
              return;
            }
            const group = input instanceof HTMLInputElement ? input.dataset.addonGroup : null;
            if (group !== 'extra' || !input.checked) return;
            this.querySelectorAll(`input[data-addon-group="${group}"]`).forEach((other) => {
              if (other !== input) other.checked = false;
            });
          });
        }

        reset() {
          this.querySelectorAll('input[data-addon-variant], input[data-addon-toggle]').forEach((input) => {
            input.checked = false;
          });
          this.dispatchEvent(new CustomEvent('ins:addons-reset', { bubbles: true }));
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variant-picker"] && !Shopify.designMode) return;
  try {
    // Móvil: al elegir una opción con foto (color), sube hasta la galería para ver la gafa
  (function () {
    if (window.__insScrollToGallery) return;
    window.__insScrollToGallery = true;
    document.addEventListener('change', function (event) {
      var input = event.target;
      if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
      if (!input.closest('.variant-option--ins-img')) return;
      if (input.closest('dialog, quick-add-dialog, .quick-add-modal')) return;
      if (!window.matchMedia('(max-width: 749px)').matches) return;
      if (window.__insFromSticky && Date.now() - window.__insFromSticky < 1500) return;
      var section = input.closest('.shopify-section');
      var gallery = section && section.querySelector('media-gallery, .product-media-gallery, slideshow-component');
      if (!gallery) return;
      setTimeout(function () {
        var header = document.querySelector('.header-section, header');
        var offset = header ? header.getBoundingClientRect().height : 0;
        var top = gallery.getBoundingClientRect().top + window.scrollY - offset - 8;
        window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
      }, 250);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variant-urgency"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('variant-urgency')) {
    customElements.define(
      'variant-urgency',
      class VariantUrgency extends HTMLElement {
        connectedCallback() {
          try {
            this.map = JSON.parse(this.querySelector('[data-urgency-map]').textContent || '{}');
          } catch (e) {
            this.map = {};
          }
          this.text = this.querySelector('.variant-urgency__text');
          this.sync = this.sync.bind(this);
          this.later = () => [150, 500, 1000, 2000].forEach((ms) => setTimeout(this.sync, ms));
          document.addEventListener('change', this.later);
          window.addEventListener('popstate', this.later);
        }

        disconnectedCallback() {
          document.removeEventListener('change', this.later);
          window.removeEventListener('popstate', this.later);
        }

        sync() {
          const section = this.closest('.shopify-section') || document;
          const input = section.querySelector('form[action*="/cart/add"] input[name="id"]');
          const id = (input && input.value) || new URL(window.location.href).searchParams.get('variant');
          if (!id || !this.text) return;
          const message = this.map[id] || '';
          this.text.textContent = message;
          this.text.hidden = message === '';
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
